/* eslint-disable no-nested-ternary */
import React, { useContext } from 'react';
import { GlobalContext } from '@mummssoftware/global-context';
import { PatientListForms } from './PatientListForms';
import { FajitaForms } from '../FajitaForms/FajitaForms';
import { SubmitPlan } from '../FajitaForms/SubmitPlan';
import { FormScrollWrapper } from '../../components/layout/WrapperDiv';

export const StandAloneForm = () => {
  const { fajitaFormGlobal } = useContext(GlobalContext);

  const embedded = false;

  return (
    <>
      <PatientListForms embedded={embedded} />

      {fajitaFormGlobal && (
        <FormScrollWrapper>
          <SubmitPlan />
          <FajitaForms />
        </FormScrollWrapper>
      )}
    </>
  );
};

export default StandAloneForm;
